import { Box } from '@mui/material';
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@provision/membership-plans-ui';
import { COPY } from '../copy';
import { useLayout, useLayoutStyles } from '../layouts/layout-context';
import type { BlockRenderProps } from '../layouts/types';
import { PlusIcon, QuestionIcon } from '../primitives/icons';
import { SectionHead } from '../primitives/section-head';
import { Wrap } from '../primitives/wrap';

export const FaqBlock = ({ plans }: BlockRenderProps) => {
  const s = useLayoutStyles('faq');
  const shared = useLayoutStyles('shared');
  const { tokens } = useLayout();
  const faqs = plans.faqs ?? [];

  if (faqs.length === 0) return null;

  return (
    <Box sx={s.section}>
      <Wrap>
        <Box sx={s.inner}>
          <SectionHead
            kicker={COPY.faqKicker}
            icon={<QuestionIcon sx={shared.kickerIcon} />}
            title={COPY.faqHeadline}
            sx={s.head}
          />
          {faqs.map((faq, index) => (
            <AccordionItem
              key={`${faq.question}\n${faq.answer}`}
              defaultExpanded={index === 0}
              elevation={0}
              sx={s.item}
            >
              <AccordionTrigger
                expandIcon={
                  <Box sx={s.expandIcon}>
                    <PlusIcon />
                  </Box>
                }
                primaryColor={tokens.brand}
                sx={s.trigger}
              >
                {faq.question}
              </AccordionTrigger>
              <AccordionContent sx={s.answer}>{faq.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Box>
      </Wrap>
    </Box>
  );
};
